import * as React from "react";
import { Lazyloader } from "../Lazyloader/Lazyloader";
import {
  IEditableEpiProperty,
  renderEditableEpiProperty,
} from "../../utils/render-editable-epi-property";

interface IHeroProps {
  heading: string;
  preamble: string;
  buttonText: string;
  buttonLink: string;
  backgroundImage: string;
  contentAlignment: string;
  isInEditMode: boolean;
  imageAlignment: string;
  backgroundImageHeight?: string;
}

export class Hero extends React.Component<IHeroProps> {
  private headingEpiProperty: IEditableEpiProperty;
  private preambleEpiProperty: IEditableEpiProperty;

  constructor(props: IHeroProps) {
    super(props);
    this.headingEpiProperty = {
      property: this.props.heading,
      propertyName: "HeroHeading",
      wrappingElement: "div",
      isInEditMode: this.props.isInEditMode,
    };
    this.preambleEpiProperty = {
      property: this.props.preamble,
      propertyName: "HeroPreamble",
      wrappingElement: "div",
      isInEditMode: this.props.isInEditMode,
    };
  }

  render(): JSX.Element {
    return (
      <article
        className={`hero ${this.props.contentAlignment} ${this.props.imageAlignment}`}
        style={
          this.props.backgroundImageHeight
            ? { height: this.props.backgroundImageHeight }
            : {}
        }
      >
        <Lazyloader
          imageUrl={this.props.backgroundImage}
          isBackgroundImage={true}
        />
        <div className="container">
          <div
            className={`row align-items-center justify-content-${this.props.contentAlignment}`}
          >
            <div className="col col-md-8 col-lg-6">
              <div className="hero__content">
                <h2 className="heading-large">
                  {renderEditableEpiProperty(this.headingEpiProperty)}
                </h2>
                <p>{renderEditableEpiProperty(this.preambleEpiProperty)}</p>
                <a
                  className="button button--fullwidth button--border-white"
                  href={this.props.buttonLink}
                >
                  {this.props.buttonText}
                </a>
              </div>
            </div>
          </div>
        </div>
      </article>
    );
  }
}
